<div class="compact-header-bg">
  <div class="compact-header-overlay"></div>
</div>
